import { jsx } from "panel";
import { PropertiesMenuEl } from "common/query-builder/query-block/properties-menu";
import { EventsMenuEl } from "common/query-builder/query-block/events-menu";
import { renameEvent } from "common/report/util/events";
import { propertySelectionToSegmentation } from "../segment-menu/util";
import { isListOfObjectsSegment } from "../segment-menu/types";
export function template() {
  var _a;
  const { searchFilter } = this.state;
  const selectedEvent = this.getSelectedEvent();
  const segmentation = ((_a = this.state.staged) == null ? void 0 : _a.property) && propertySelectionToSegmentation(this.state.staged.property);
  let menuEl;
  if (selectedEvent == null ? void 0 : selectedEvent.value) {
    menuEl = /* @__PURE__ */ jsx(PropertiesMenuEl, {
      attrs: {
        ...this.attrs(),
        "search-filter": searchFilter,
        "event-names": [selectedEvent.value],
        selected: this.getSelectedProperty(),
        "all-data-groups": false,
        "project-has-people": false,
        "project-has-cohorts": false,
        "property-of-label": renameEvent(selectedEvent.value)
      },
      key: "properties-menu",
      props: {
        context: `breakdown`,
        backButtonHandler: () => {
          if (this.state.staged.property) {
            this.update({
              staged: { ...this.state.staged, property: null }
            });
          } else {
            this.update({ staged: null });
          }
        }
      },
      params: {
        listProperty: isListOfObjectsSegment(segmentation) ? segmentation : null
      },
      on: {
        select: this.helpers.handleSelectProperty,
        tooltipContextEditDescription: this.helpers.propagateEvent,
        openedModal: this.helpers.propagateEvent,
        closedModal: this.helpers.propagateEvent
      },
      hook: { insert: (vnode) => this.childMenu = vnode.elm }
    });
  } else {
    menuEl = /* @__PURE__ */ jsx(EventsMenuEl, {
      attrs: {
        open: this.attr(`open`),
        "search-filter": searchFilter,
        "data-group-id": this.attr(`data-group-id`),
        "project-id": this.attr(`project-id`),
        "workspace-id": this.attr(`workspace-id`),
        selected: this.getSelectedEvent()
      },
      props: {
        context: `breakdown`
      },
      key: "events-menu",
      on: {
        select: (ev) => this.handleSelectEvent(ev.detail.item),
        tooltipContextAction: this.helpers.propagateEvent,
        tooltipContextEditDescription: this.helpers.propagateEvent
      },
      hook: { insert: (vnode) => this.childMenu = vnode.elm }
    });
  }
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-breakdown-menu"
  }, menuEl);
}
